export default __webpack_public_path__ + "media/footer_bg.4ca0cfbd.svg";